<mp-list-item-selector
  [multipleSelection]="true"
  [options]="vm.filteredUsersOptions()"
  [isLoading]="isLoadingUsers()"
  [idFn]="getUserId"
  noOptionsLabel="Keine Benutzer gefunden"
  (searched)="onUserSearchTermChange($event)"
  (selectedValuesChange)="onSelectedUsersChange($event)"
/>
